/**
 * №13.1 (§1.5 / №11.1.2) — the governed-field lock affordance. A padlock + the
 * correction sentence naming the path back to editability. Rendered proactively
 * (from governance-map) so the user never meets an editable input that 500s on
 * save; `fix` is the affordance to the correction (e.g. "Reopen matter").
 */
export function GovernedNotice({ message, fix, onFix }: { message: string; fix?: string; onFix?: () => void }) {
  return (
    <div className="governed">
      <span className="pad">🔒</span>
      <span>{message}</span>
      {fix ? (
        onFix ? (
          <button className="fix" style={{ border: "none", background: "none", cursor: "pointer", font: "inherit" }} onClick={onFix}>{fix} →</button>
        ) : (
          <span className="fix">{fix} →</span>
        )
      ) : null}
    </div>
  );
}
